<!-- Edit Panel Code -->
<p-dialog id="EditDialog" [(visible)]="caisExceptionServiceService.isCaisEdit" appendTo="body" height="auto"
  width="auto" (onHide)="caisExceptionServiceService.isCaisEdit=false" [style]="{width: '78%', minWidth: '550px'}"
  [minY]="100" [maximizable]="true" minimizeIcon="pi pi-window-minimize" maximizeIcon="pi pi-window-maximize"
  closeIcon="pi pi-times" [focusOnShow]="false" [modal]="false" draggable="true"
  styleClass= "edit-fdid-form-dialog">
  <ng-template #header class= "dialog-header">Edit {{screenType}}</ng-template>
    <div class="col-lg-12 nopadding">
      @if(isEditLoadingResults){
      <div class="example-loading-shade">
        <mat-spinner></mat-spinner>
      </div>
      }

      @if(caisExceptionServiceService.isCaisEdit){
      <div class="ui-grid-col-12 container">
        <app-record-details 
          [ExceptionCodeDetailsCols]="ExceptionCodeDetailsCols"
          [rowDataforDialog]="finraExceptionRow">
        </app-record-details>

        <app-error-code-details 
          [ExceptionCodesDetails]="ExceptionCodesDetails">
        </app-error-code-details>

        <app-fdid-record-details
          [fdidScreenDataDetails]="fdidScreenDataDetails"
          [editScreenNegotiatedFields]="editScreenNegotiatedFields"
          [ExceptionalFDIDScreenFields]="ExceptionalFDIDScreenFields" 
          [editDisabledFields]="editDisabledFields">
        </app-fdid-record-details>

      </div>
      }
      
      <!-- End of Record Details -->
      <app-ltid-details
        [LTIDGridColumns]="LTIDGridColumns">
      </app-ltid-details>

      <app-address-details 
        [addressColumns]="addressColumns">
      </app-address-details>
      
      <app-customerlist-details
        [finraExceptionRow]="finraExceptionRow"
        [NaturalPersons]="NaturalPersons"
        [LegalEntities]="LegalEntities" 
        [ExceptionInCustomerIDList]="ExceptionInCustomerIDList"
        [NaturalPersonScreenDataDetails]="NaturalPersonScreenDataDetails"
        [LegalEntityScreenDataDetails]="LegalEntityScreenDataDetails"
        [addressColumns]="addressColumns">
      </app-customerlist-details>
    </div>
    <ng-template #footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <p-button class="edit-fdid-footer-button" type="button" icon="fa fa-close" id="CloseEditDialog"
        (click)="caisExceptionServiceService.isCaisEdit=false" label="Close">
      </p-button>
      <p-button class="edit-fdid-footer-button" type="button" icon="fa fa-check" id="editSaveDialog" (click)="saveFDIDRecord();" [disabled]="false"
        label="Save">
      </p-button>
    </div>
    </ng-template>
</p-dialog>
<!-- End of Editing Panel Code -->